export const RESET_STATE = 'RESET_STATE';
export const SET_ACTIVE_NAV_MENU_ITEM_ID = 'SET_ACTIVE_NAV_MENU_ITEM_ID';
export const SET_STORAGE_SPACE = 'SET_STORAGE_SPACE';
export const SET_SETUP_PASSWORD_STATUS = 'SET_SETUP_PASSWORD_STATUS';
export const SET_CONTENT_ITEMS = 'SET_CONTENT_ITEMS';
export const SET_FETCH_STORAGE_SPACE_STATUS = 'SET_FETCH_STORAGE_SPACE_STATUS';
export const SET_FETCH_CONTENT_ITEMS_STATUS = 'SET_FETCH_CONTENT_ITEMS_STATUS';
export const SET_POST_LOGIN_OPEN_ARCHIVE_ID = 'SET_POST_LOGIN_OPEN_ARCHIVE_ID';
export const SET_POST_LOGIN_OPEN_NAV_MENU_ID = 'SET_POST_LOGIN_OPEN_NAV_MENU_ID';
export const SET_ACTIVE_CONTENT_TYPE = 'SET_ACTIVE_CONTENT_TYPE';
export const SET_SHARED_CONTENT_ITEMS = 'SET_SHARED_CONTENT_ITEMS';
export const SET_FETCH_SHARED_CONTENT_ITEMS_STATUS = 'SET_FETCH_SHARED_CONTENT_ITEMS_STATUS';
export const SET_USER_SUBSCRIPTION = 'SET_USER_SUBSCRIPTION';
export const SET_USER_SUBSCRIPTION_TYPE = 'SET_USER_SUBSCRIPTION_TYPE';
export const SET_APP_FEATURES = 'SET_APP_FEATURES';
export const SET_FILE_VERSIONS = 'SET_FILE_VERSIONS';
export const SET_FETCH_FILE_VERSIONS_STATUS = 'SET_FETCH_FILE_VERSIONS_STATUS';
export const SET_SHARED_LINK = 'SET_SHARED_LINK';
export const SET_CREATE_SHARED_LINK_STATUS = 'SET_CREATE_SHARED_LINK_STATUS';
export const SET_DELETE_SHARED_LINK_STATUS = 'SET_DELETE_SHARED_LINK_STATUS';
export const SET_SHARED_LINK_SETTINGS = 'SET_SHARED_LINK_SETTINGS';
export const SET_FETCH_SHARED_LINK_SETTINGS_STATUS = 'SET_FETCH_SHARED_LINK_SETTINGS_STATUS';
export const SET_UPDATE_SHARED_LINK_SETTINGS_STATUS = 'SET_UPDATE_SHARED_LINK_SETTINGS_STATUS';
export const SET_SEARCH_ENABLED_SATE = 'SET_SEARCH_ENABLED_SATE';
export const SET_SEARCH_RESULT_RECEIVED = 'SET_SEARCH_RESULT_RECEIVED';
export const SET_ACTIVE_VERSION_PATH = 'SET_ACTIVE_VERSION_PATH';
export const SET_ACTIVE_VOLUME_PATH = 'SET_ACTIVE_VOLUME_PATH';
export const SET_ACTIVE_FOLDER_ITEM = 'SET_ACTIVE_FOLDER_ITEM';
export const SET_SUB_ACCOUNT_ITEMS = 'SET_SUB_ACCOUNT_ITEMS';
export const SET_VOLUME_SB_MACHINES = 'SET_VOLUME_SB_MACHINES';
export const SET_FETCH_SUB_ACCOUNT_ITEMS_STATUS = 'SET_FETCH_SUB_ACCOUNT_ITEMS_STATUS';
export const SET_ACTIVE_SUB_ACCOUNT_DISPLAY_NAME = 'SET_ACTIVE_SUB_ACCOUNT_DISPLAY_NAME';
export const SET_ACTIVE_SUB_ACCOUNT_ID = 'SET_ACTIVE_SUB_ACCOUNT_ID';
export const SET_ACTIVE_VOLUME_SB_SUB_ACCOUNT_ID = 'SET_ACTIVE_VOLUME_SB_SUB_ACCOUNT_ID';
export const SET_ACTIVE_VOLUME_SUBSCRIPTION = 'SET_ACTIVE_VOLUME_SUBSCRIPTION';
export const SET_CHECK_SUB_ACCOUNT_STATUS = 'SET_CHECK_SUB_ACCOUNT_STATUS';
export const SET_FETCH_SUB_ACCOUNT_ARCHIVES_STATUS = 'SET_FETCH_SUB_ACCOUNT_ARCHIVES_STATUS';
export const SET_SUB_ACCOUNT_ARCHIVES = 'SET_SUB_ACCOUNT_ARCHIVES';
